<template>
    <div>
        <div class="slidebar animate__animated animate__fadeInLeft">
            <img src="../../assets/imgs/appoint/slide_bar.png" alt="" />
            <ul>
                <li class="ios"><a :href="gameData.ios_url" target="_blank"></a></li>
                <li class="gp"><a :href="gameData.android_url" target="_blank"></a></li>
                <li class="fb"><a :href="gameData.fb_fans_url" target="_blank"></a></li>
                <li class="mycard"><a :href="gameData.apk_url" target="_blank"></a></li>
                <li class="youtube"><a href="https://www.youtube.com/channel/UC3KvvLdnZ7QYwh3m4M4KsUg" target="_blank"></a></li>
            </ul>
            <a href="javascript:;" class="top" @click="backTop()">
                <img src="../../assets/top.png" alt="" class="top_bot" />
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "SlideBar",
    props: {
        msg: String,
        gameData: Object
    },
    data () {
        return {
            isSlideBar: false
        };
    },
    created (){
    },
    mounted () {
    },
    methods: {
        backTop () {
            // 点击返回顶部，返回距离顶部1080px的距离
            let top =
                document.documentElement.scrollTop || document.body.scrollTop;
            const timeTop = setInterval(() => {
                document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
                if (top <= 0) {
                    this.isSlideBar = true;
                    clearInterval(timeTop);
                }
            }, 10);
        }
    }
};
</script>

<style scoped lang="scss">
@keyframes top_bot {
    0% {
        bottom: 0.23rem;
    }
    20% {
        bottom: 0.26rem;
    }
    50% {
        bottom: 0.34rem;
    }
    60% {
        bottom: 0.3rem;
    }
    80% {
        bottom: 0.26rem;
    }
    100% {
        bottom: 0.23rem;
    }
}
.slidebar {
    position: fixed;
    width: 2.12rem;
    height: 5.42rem;
    top: 25%;
    left: 0;
    z-index: 110;
    .top {
        display: inline-block;
        position: absolute;
        width: 0.56rem;
        height: 0.5rem;
        bottom: 0.89rem;
        left: 50%;
        margin-left: -0.28rem;
    }
    .top_bot {
        display: inline-block;
        position: absolute;
        width: 0.24rem;
        height: 0.15rem;
        bottom: 0.23rem;
        left: 50%;
        margin-left: -0.12rem;
        z-index: 999999;
        animation: top_bot 1s ease infinite;
        cursor: pointer;
    }
}
.slidebar ul {
    width: 1.33rem;
    height: 2.31rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -0.66rem;
    margin-top: -2.4rem;
    z-index: 117;
}
.slidebar ul li {
    width: 100%;
    height: 0.42rem;
    position: absolute;
    cursor: pointer;
    /**background: pink;
    opacity: 0.8;**/
    a {
        display: inline-block;
        width: 100%;
        height: 100%;
    }
    &:nth-child(1) {
        top: 0;
    }
    &:nth-child(2) {
        top: 0.5rem;
    }
    &:nth-child(3) {
        top: 1.42rem;
    }
    &.mycard{
        top: .95rem;
    }
    &.youtube{
        top: 1.89rem;
    }
}
</style>
